import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import LoginModal from '../../../components/Auth/LoginModal/LoginModal';
import { nbsApiEmailLogin } from '../../../store/actions/emailLogin';
import {
  setSessionToken,
  getSessionInitCookie,
  setSessionInitCookie,
} from '../../../store/actions/session';
import { getRomanceGuardParam } from '../../../assets/helpers/utils';
import PropsRoute from '../../../hoc/PropsRoute/PropsRoute';
import Auxi from '../../../hoc/Auxi/Auxi';
import IndexPage from '../../IndexPage/IndexPage';
import paths from '../../../constants/paths';
import { gtmTrack } from '../../../assets/helpers/GAHelper';

class LoginContainer extends Component {
  state = {
    showAlert: false,
    errorMessage: null,
    showSpinner: false,
    showReactivateModal: false,
  };

  componentDidUpdate(prevProps) {
    // Toggle Spinner Based on Fetching Status
    if (this.props.emailLogin.isFetching !== prevProps.emailLogin.isFetching) {
      this.setState({ showSpinner: this.props.emailLogin.isFetching });
    }

    // Handle Email Login Success
    if (
      this.props.emailLogin.status === 'success' &&
      prevProps.emailLogin.status !== 'success'
    ) {
      this.props.setSessionToken(this.props.emailLogin.response.token);
      gtmTrack({
        event: 'login',
        method: 'regular',
      });
    }

    // Handle Email Login Failure
    if (
      this.props.emailLogin.status === 'fail' &&
      prevProps.emailLogin.status !== 'fail'
    ) {
      if (this.props.emailLogin.error.error_code === 3) {
        this.setState({ showReactivateModal: true });
      } else {
        this.toggleAlertError(this.props.emailLogin.error.error);
        gtmTrack({
          event: 'login_error',
          message: this.props.emailLogin.error.error,
        });
      }
    }

    // Redirect to INDEX if account is deleted
    if (
      this.props.checkAccountStatus.delete &&
      !prevProps.checkAccountStatus.delete &&
      !this.state.showAlert
    ) {
      this.props.history.push(paths.INDEX);
    }
  }

  goBack = () => {
    if (this.props.history.action === 'PUSH') {
      this.props.history.goBack();
    } else {
      this.props.history.push(paths.INDEX);
    }
  };

  toggleAlertError = (errorMessage) => {
    this.setState({ showAlert: !this.state.showAlert, errorMessage });
  };

  emailLogin = (email, password, activate = null) => {
    const obj = {
      email,
      password,
      login_type: 'regular',
      device_type: 3,
      platform: 'web',
      activate,
      __RG: getRomanceGuardParam(),
    };
    if (!getSessionInitCookie()) {
      this.props.nbsApiEmailLogin(obj);
      setSessionInitCookie();
    } else if (activate) {
      // console.log('AKTIVIRAJ GA BRE@@@@@');
      this.props.nbsApiEmailLogin(obj);
    }
  };

  render() {
    return (
      <Auxi>
        {this.props.isLandscape ? (
          <PropsRoute
            isLandscape={this.props.isLandscape}
            component={IndexPage}
          />
        ) : null}
        <LoginModal
          showSpinner={this.state.showSpinner}
          isLandscape={this.props.isLandscape}
          nbsApiEmailLogin={this.props.nbsApiEmailLogin}
          emailLogin={this.emailLogin}
          showErrorAlert={this.state.showAlert}
          showReactivateModal={this.state.showReactivateModal}
          errorAlertMessage={this.state.errorMessage}
          dismissAlert={this.toggleAlertError}
          goBack={this.goBack}
        />
      </Auxi>
    );
  }
}

function mapStateToProps(state) {
  return {
    emailLogin: state.emailLogin,
    getConfig: state.getConfig,
    checkAccountStatus: state.checkAccountStatus,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      nbsApiEmailLogin,
      setSessionToken,
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);



// WEBPACK FOOTER //
// ./src/containers/Auth/Login/LoginContainer.js